"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationRequests = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const utcOperations_1 = require("../utcOperations");
const TimeBuckets_1 = require("./TimeBuckets");
const types_1 = require("./types");
/**
 * History store must be constructed such that no key/arrays that have intermediate timestamps are present for key entries that represent previous and current data readings
 * eg if { x: number } is expected every two hours, and { y: number } is expected every 1 hour, to correctly record x, y must not be present.
 * This applies to sets of attributes eg Activity and Condition report in v-0-1-5
 * @param param0
 * @returns
 */
const getAccumulationRequests = ({ currentTimestamp, historyStore: historyStoreIn, validBusinessObject, }) => {
    let accumulationRequests = undefined;
    const historyStore = historyStoreIn.clone();
    const timeBucketDef = {
        unit: types_1.TimeBucketUnits.HOUR,
        width: 1,
    };
    const lastCompleteBucket = (0, TimeBuckets_1.getCurrentTimeBucket)(timeBucketDef, currentTimestamp - timeBucketDef.unit * timeBucketDef.width);
    let lastEvaluatedTimestamp = undefined;
    const coveringStateSnapshots = [];
    let rangeCoversBucket = false;
    do {
        const snapshot = historyStore.pop();
        if (snapshot) {
            const [startTimestamp, endTimestamp] = lastCompleteBucket;
            if (coveringStateSnapshots.length === 0) {
                const preceedingTimestamp = historyStore.getLastTimestamp();
                if ((preceedingTimestamp ?? 0) < endTimestamp) {
                    coveringStateSnapshots.unshift(snapshot);
                }
                /** don't put in timestamps that will be out of order otherwise covers range will always be false */
            }
            else if (snapshot.timestamp < coveringStateSnapshots[0].timestamp) {
                coveringStateSnapshots.unshift(snapshot);
            }
            else {
                console.log(`WARN: history store has out of order elements at ${snapshot.timestamp}, the current start timestamp is ${coveringStateSnapshots[0].timestamp}`);
            }
        }
        rangeCoversBucket = (0, TimeBuckets_1.coversRange)(lastCompleteBucket, coveringStateSnapshots.map((snapshot) => snapshot.timestamp));
    } while (historyStore.getLength() > 0 && !rangeCoversBucket && (lastEvaluatedTimestamp ?? Infinity >= lastCompleteBucket[0]));
    // at this point the first snapshot is outside the bucket but its timestamp should be used as the start of the first measure range
    if (coveringStateSnapshots.length >= 2) {
        const currentBucketApportionmentMaps = [];
        for (let i = 1; i < coveringStateSnapshots.length; i++) {
            const measureValueMapRange = {
                fromTimestamp: coveringStateSnapshots[i - 1].timestamp,
                toTimestamp: coveringStateSnapshots[i].timestamp,
                valueMap: coveringStateSnapshots[i].state,
            };
            const bucketApportionmentRes = (0, TimeBuckets_1.apportionMeasureValuesMap)({ timeBucketDef, measureValueMapRange });
            const currentBucketApportionment = bucketApportionmentRes.find((bucketApportionment) => bucketApportionment.bucket[0] === lastCompleteBucket[0] && bucketApportionment.bucket[1] === lastCompleteBucket[1]);
            if (currentBucketApportionment) {
                currentBucketApportionmentMaps.push(currentBucketApportionment.apportionedValuesMap);
            }
            else {
                const msg = `Bucket mismatch cant find current bucket in apportionment result`;
                console.log(msg, JSON.stringify({ currentTimestamp, currentBucket: lastCompleteBucket, bucketApportionmentRes, measureValueMapRange }, null, 1));
                // throw new Error( msg)
            }
        }
        if (currentBucketApportionmentMaps.length > 0) {
            const accumlatedValueMap = {};
            currentBucketApportionmentMaps.forEach((map) => {
                Object.entries(map).map(([k, v]) => {
                    if (typeof v === 'number') {
                        if (!accumlatedValueMap[k]) {
                            accumlatedValueMap[k] = 0;
                        }
                        accumlatedValueMap[k] = accumlatedValueMap[k] + v;
                    }
                });
            });
            const [y, month, day, hour] = (0, utcOperations_1.timestampToYMDHMS)(currentTimestamp);
            const acculationRequest = {
                accessor: { month, day: (day - 1), hour },
                accumulationClassName: iotv_v3_types_1.AccumulatorClasses.HourlyYearBasedNormalAccumulator,
                update: accumlatedValueMap,
                validBusinessObject,
            };
            if (!accumulationRequests)
                accumulationRequests = [];
            accumulationRequests.push(acculationRequest);
        }
    }
    return accumulationRequests;
};
exports.getAccumulationRequests = getAccumulationRequests;
